module.exports = [
	{
		"fragment": "1",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "1N",
				"pitch": 90,
				"yaw": 70,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "2",
				"pitch": 45,
				"yaw": 138,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "3",
				"pitch": -65,
				"yaw": 50,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "6",
				"pitch": -110,
				"yaw": 85,
				"radius": 0.05,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Nightlight",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": 90,
				"yaw": 76,
				"distance": 1
			},
			{
				"text": "Capacity<br>Overhead bins<br>Customizable texts<br>Opportunity to upsell",
				"fontSize": "80px",
				"pitch": 10,
				"yaw": 180,
				"distance": 1
			}
		]
	},
	{
		"fragment": "1N",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "1",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "2",
				"pitch": -37,
				"yaw": 25,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "3",
				"pitch": -37,
				"yaw": -25,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "6N",
				"pitch": -5,
				"yaw": 2,
				"radius": 0.05,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Daylight",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": 32,
				"yaw": 0,
				"distance": 1
			}
		]
	},
	{
		"fragment": "2",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "3",
				"pitch": -50,
				"yaw": -80,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "1",
				"pitch": -40,
				"yaw": -130,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Isle",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": -31,
				"yaw": -127,
				"distance": 1
			},
			{
				"text": "←  17\" (43cm) Wide  →<br>Comfortable Seat<br><br>Customizable texts<br>Opportunity to upsell",
				"fontSize": "40px",
				"pitch": -20,
				"yaw": 0,
				"distance": 1
			}
		]
	},
	{
		"fragment": "3",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "2",
				"pitch": -80,
				"yaw": 82,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "1",
				"pitch": -30,
				"yaw": 140,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Isle",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": -21,
				"yaw": 138,
				"distance": 1
			},
			{
				"text": "←  17\" (43cm) Wide  →<br>Comfortable Seat<br><br>Customizable texts<br>Opportunity to upsell",
				"fontSize": "40px",
				"pitch": -22,
				"yaw": 0,
				"distance": 1
			},
			{
				"text": "←  31\" (79cm) pitch  →<br>Economy class<br><br>Customizable texts<br>Opportunity to upsell",
				"fontSize": "40px",
				"rotation": -8,
				"pitch": -57,
				"yaw": -55,
				"distance": 1
			}
		]
	},
	{
		"fragment": "4",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "5",
				"pitch": 110,
				"yaw": -100,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "6",
				"pitch": -40,
				"yaw": -140,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Isle",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": -32,
				"yaw": -137,
				"distance": 1
			}
		]
	},
	{
		"fragment": "5",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "4",
				"pitch": 90,
				"yaw": 105,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "6",
				"pitch": -40,
				"yaw": 140,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Isle",
				"fontSize": "40px",
				"fontWeight": "Bold",
				"pitch": -32,
				"yaw": 137,
				"distance": 1
			},
			{
				"text": "←  20\" (50cm) wide  →<br>Ultra comfortable<br>Business seat<br><br>Customizable texts<br>Opportunity to upsell",
				"fontSize": "40px",
				"pitch": -16,
				"yaw": -2,
				"distance": 1
			},
			{
				"text": "←  37\" (93cm) pitch  →<br>Business class<br><br>Customizable texts<br>Opportunity to upsell",
				"rotation": 8,
				"pitch": -42,
				"yaw": 60,
				"distance": 1
			}
		]
	},
	{
		"fragment": "6",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "6N",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "1",
				"pitch": -3,
				"yaw": 1,
				"radius": 0.05,
				"distance": 1
			},
			{
				"fragment": "5",
				"pitch": -30,
				"yaw": 27,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "4",
				"pitch": -30,
				"yaw": -20,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Nightlight",
				"fontWeight": "Bold",
				"fontSize": "40px",
				"pitch": 32,
				"yaw": 0,
				"distance": 1
			}
		]
	},
	{
		"fragment": "6N",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "6",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "1N",
				"pitch": -3,
				"yaw": 1,
				"radius": 0.05,
				"distance": 1
			},
			{
				"fragment": "5",
				"pitch": -30,
				"yaw": 27,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "4",
				"pitch": -30,
				"yaw": -20,
				"radius": 0.075,
				"distance": 1
			}
		],
		"texts": [
			{
				"text": "Daylight",
				"fontWeight": "Bold",
				"fontSize": "40px",
				"pitch": 32,
				"yaw": 0,
				"distance": 1
			}
		]
	},
	{
		"fragment": "7",
		"default_yaw": 180,
		"hotspots": [
			{
				"fragment": "8",
				"pitch": 5,
				"yaw": 165,
				"radius": 0.05,
				"distance": 1
			},
			{
				"fragment": "9",
				"pitch": -7,
				"yaw": 15,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "10",
				"pitch": 10,
				"yaw": -150,
				"radius": 0.075,
				"distance": 1
			}
		]
	},
	{
		"fragment": "8",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "7",
				"pitch": -20,
				"yaw": 130,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "9",
				"pitch": -60,
				"yaw": 82,
				"radius": 0.075,
				"distance": 1
			}
		]
	},
	{
		"fragment": "9",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "7",
				"pitch": -20,
				"yaw": -130,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "8",
				"pitch": -60,
				"yaw": -82,
				"radius": 0.075,
				"distance": 1
			}
		]
	},
	{
		"fragment": "10",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "7",
				"pitch": -20,
				"yaw": -130,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "8",
				"pitch": 0,
				"yaw": -70,
				"radius": 0.05,
				"distance": 1
			}
		]
	},
	{
		"fragment": "11",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "11N",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "12",
				"pitch": 45,
				"yaw": 148,
				"radius": 0.12,
				"distance": 1
			},
			{
				"fragment": "13",
				"pitch": 50,
				"yaw": -156,
				"radius": 0.12,
				"distance": 1
			},
			{
				"fragment": "14",
				"pitch": 5,
				"yaw": 181,
				"radius": 0.05,
				"distance": 1
			}
		]
	},
	{
		"fragment": "11N",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "11",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "12",
				"pitch": 45,
				"yaw": 148,
				"radius": 0.12,
				"distance": 1
			},
			{
				"fragment": "13",
				"pitch": 50,
				"yaw": -156,
				"radius": 0.12,
				"distance": 1
			},
			{
				"fragment": "14N",
				"pitch": 5,
				"yaw": 181,
				"radius": 0.05,
				"distance": 1
			}
		]
	},
	{
		"fragment": "12",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "11",
				"pitch": 12,
				"yaw": -23,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "13",
				"pitch": -90,
				"yaw": -70,
				"radius": 0.1,
				"distance": 1
			}
		]
	},
	{
		"fragment": "13",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "11",
				"pitch": 12,
				"yaw": 23,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "12",
				"pitch": -80,
				"yaw": 77,
				"radius": 0.12,
				"distance": 1
			}
		]
	},
	{
		"fragment": "14",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "14N",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "11",
				"pitch": -3,
				"yaw": 1,
				"radius": 0.05,
				"distance": 1
			},
			{
				"fragment": "15",
				"pitch": 30,
				"yaw": 162,
				"radius": 0.1,
				"distance": 1
			},
			{
				"fragment": "16",
				"pitch": 30,
				"yaw": -149,
				"radius": 0.1,
				"distance": 1
			}
		]
	},
	{
		"fragment": "14N",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "14",
				"pitch": 39,
				"yaw": 0,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "11N",
				"pitch": -3,
				"yaw": 1,
				"radius": 0.05,
				"distance": 1
			},
			{
				"fragment": "15",
				"pitch": 30,
				"yaw": 162,
				"radius": 0.1,
				"distance": 1
			},
			{
				"fragment": "16",
				"pitch": 30,
				"yaw": -149,
				"radius": 0.1,
				"distance": 1
			}
		]
	},
	{
		"fragment": "15",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "14",
				"pitch": 12,
				"yaw": -23,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "16",
				"pitch": -80,
				"yaw": -78,
				"radius": 0.12,
				"distance": 1
			}
		]
	},
	{
		"fragment": "16",
		"default_yaw": 0,
		"hotspots": [
			{
				"fragment": "14",
				"pitch": 12,
				"yaw": 23,
				"radius": 0.075,
				"distance": 1
			},
			{
				"fragment": "15",
				"pitch": -80,
				"yaw": 78,
				"radius": 0.1,
				"distance": 1
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/hotspots.json
// module id = 3
// module chunks = 0